var _rect, _path, _path2, _path3, _path4, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 13.875C12.7892 13.875 13.125 14.2108 13.125 14.625V24C13.125 24.8284 13.7966 25.5 14.625 25.5H21.375C22.2034 25.5 22.875 24.8284 22.875 24V14.625C22.875 14.2108 23.2108 13.875 23.625 13.875C24.0392 13.875 24.375 14.2108 24.375 14.625V24C24.375 25.6569 23.0319 27 21.375 27H14.625C12.9681 27 11.625 25.6569 11.625 24V14.625C11.625 14.2108 11.9608 13.875 12.375 13.875Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.125 9C15.2966 9 14.625 9.67157 14.625 10.5V11.25L10.875 11.25C10.4608 11.25 10.125 11.5858 10.125 12C10.125 12.4142 10.4608 12.75 10.875 12.75L25.125 12.75C25.5392 12.75 25.875 12.4142 25.875 12C25.875 11.5858 25.5392 11.25 25.125 11.25L21.375 11.25V10.5C21.375 9.67157 20.7034 9 19.875 9H16.125ZM19.875 11.25V10.5H16.125V11.25L19.875 11.25Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.125 23.25C15.7108 23.25 15.375 22.9142 15.375 22.5V16.5C15.375 16.0858 15.7108 15.75 16.125 15.75C16.5392 15.75 16.875 16.0858 16.875 16.5V22.5C16.875 22.9142 16.5392 23.25 16.125 23.25Z",
    fill: "#777777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.875 23.25C19.4608 23.25 19.125 22.9142 19.125 22.5V16.5C19.125 16.0858 19.4608 15.75 19.875 15.75C20.2892 15.75 20.625 16.0858 20.625 16.5V22.5C20.625 22.9142 20.2892 23.25 19.875 23.25Z",
    fill: "#777777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    stroke: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.429fb6b72b1ea52ec7adc50409560411.svg";
export { ForwardRef as ReactComponent };